import { Nav, Navbar, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector } from "react-redux";

import "./index.css";
import { useEffect } from "react";

const style = {
  marginBottom: "0px",
  position: "fixed",
  top: "0",
  left: "0",
  width: "100%",
  zIndex: "10",
  borderRadius: "0px",
};

const User = {
  fontSize: "18px",
  color: "white",
  display: "inline-block",
  paddingRight: "20px",
};

const Divider = {
  display: "inline-block",
  height: "16px",
  borderLeft: "2px solid white",
  borderRight: "1px solid white",
  marginRight: "20px",
};

const LogOut = {
  fontSize: "18px",
  color: "white",
  fontWeight: "bold",
};

const NavBar = (props) => {
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (user?.userGroup?.name === "configurator") {
      props.history.push("/configurable-products");
    }
  }, [user]);

  return (
    <Navbar bg="dark" expand="lg" style={style} className="lc-navbar-container">
      <Navbar.Brand>
        <a className="lc-navbar-header-link" href="logo">
          Server Builds
        </a>
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse>
        <Nav className="navbar-nav ml-auto">
          <NavItem>
            <p style={User}>{user.email ? user.email : "User Email"}</p>
            <span style={Divider} />
          </NavItem>
          <LinkContainer to="/logout">
            <NavItem>
              <p style={LogOut}>Log Out</p>
            </NavItem>
          </LinkContainer>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavBar;
